import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { ApplicationCreation } from '@/services/apis';

const initialState = {
  applications: [],
  totalCount: 0,
  loading: true,
  error: false,
  errorMessage: ''
};

export const fetchAllApplications = createAsyncThunk('applicationCreation/fetchAllApplications', async () => {
  const response = await ApplicationCreation.fetchApplications();
  return response;
});

export const createNewApplication = createAsyncThunk(
  'applicationCreation/createNewApplication',
  async (body: any) => {
    const response = await ApplicationCreation.createApplication(body);
    return response;
  },
);

export const ApplicationCreationSlice = createSlice({
  name: 'applicationCreation',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchAllApplications.pending, (state) => {});
    builder.addCase(fetchAllApplications.fulfilled, (state, { payload }) => {
      return {
        ...state,
        applications: payload?.result?.applications,
        totalCount: payload?.result?.applications?.length,
        loading: false,
      };
    });
    builder.addCase(fetchAllApplications.rejected, (state) => {
      return { ...state, applications: [], totalCount: 0, loading: false };
    });
  }
});

export const applicationCreationSelector = (state: any) => state.applicationCreation;

export default ApplicationCreationSlice.reducer;
